import useIndicativePriceSummary from "./useIndicativePriceSummary";

export default useIndicativePriceSummary;
